/**
 * Delete Project Use Case
 *
 * Deletes an existing project.
 * This use case handles the business logic for project deletion,
 * including validation and data transformation.
 */

import type { IProjectsGateway } from "../ports/IProjectsGateway";

export class DeleteProjectUseCase {
  constructor(private readonly projectsGateway: IProjectsGateway) {}

  async execute(projectId: string): Promise<void> {
    // Validate project ID
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }

    // Check if project exists before attempting deletion
    try {
      await this.projectsGateway.getProjectDetails(projectId);
    } catch {
      throw new Error("Project not found");
    }

    return this.projectsGateway.deleteProject(projectId);
  }
}
